/**
 * The palette every HTML map marker is painted from — lifted from
 * `apps/web/.../FleetMap/markerEncoding.ts` (MAP-4) so the console's maps and
 * the tenant app's maps encode against the SAME mode.
 *
 * Markers sit on BASEMAP TILES, not on an app surface, so a mode has to be
 * CHOSEN rather than resolved: the marker factories build raw DOM with no theme
 * to read and no cascade to inherit from. Light is the correct choice because
 * the light slots are the darker, more saturated end of each hue — the pair
 * that reads against map tiles behind a white ring. The dark slots are lifted
 * for a dark app surface and would wash out over imagery.
 *
 * Exported so the marker DOM factories and every legend encode against the
 * same mode — three copies of this decision is how the three drift apart.
 */
import { color } from "../../theme/tokens/color.js";

export const MARKER_MODE = "light" as const;

/** The light token set every marker is painted from. */
export const MARKER = color[MARKER_MODE];

/**
 * Neutral glyph fill — locations, the year mode, and "none / never" states.
 *
 * `borders.control` (not `status.neutral`): this is the ABSENCE of a state.
 * `borders.control` is the system's non-text neutral: deliberately below the
 * text floor, above the 3:1 non-text bar — a real mark on tiles (3.96 on the
 * canvas, 4.30 against the marker's own white ring). See the original
 * `markerEncoding.ts` docblock for the recorded finding that this sits 1.26:1
 * from `severity.info`; the distinction rests on FORM and on the legend label,
 * which is what D26 requires anyway.
 */
export const NEUTRAL_COLOR = MARKER.borders.control;
